(() => {
  const fallback='https://book.diamondsbyraymondlee.com';
  let origin=fallback;try{const u=new URL(document.querySelector('meta[name="dbrl-booking-origin"]')?.content||fallback);if(u.protocol==='https:'&&!u.username&&!u.password&&u.pathname==='/'&&!u.search&&!u.hash)origin=u.origin;}catch{}
  const services=["fine-jewelry-shopping-appointment","engagement-bridal-consultation","trade-in-shopping-appointment","custom-jewelry-design-consultation","private-appointment-proposalconstulation","sell-watch-appointment","sell-your-jewelry-diamonds","instant-sell-quote","sell-luxury-handbags","consignment-consultation","collateral-loan-consultation","jewelry-watch-repair-consultation","jewelry-appraisal-appointment","insurance-replacement-consultation","interview-appointment","influencer-x-diamonds-by-raymond-lee","private-appointment-with-barbie"];
  const contextKeys=['product','variant','piece','size','utm_source','utm_medium','utm_campaign','utm_content','utm_term','a1'];
  const legacyPath=u=>{const slug=u.pathname.split('/').filter(Boolean).pop();return slug==='private-high-jewelry-viewing'?'/high-jewelry':services.includes(slug)?'/book/'+slug:'/';};
  // General booking buttons inherit the service of the current landing page.
  const pageBookings={
  "/pages/bridal": "/book/engagement-bridal-consultation",
  "/pages/emerald-engagement-rings-boca-raton": "/book/engagement-bridal-consultation",
  "/pages/ruby-engagement-rings-boca-raton": "/book/engagement-bridal-consultation",
  "/pages/sapphire-engagement-rings-boca-raton": "/book/engagement-bridal-consultation",
  "/pages/tanzanite-engagement-rings-boca-raton": "/book/engagement-bridal-consultation",
  "/pages/jewelry-repair-boca-raton": "/book/jewelry-watch-repair-consultation",
  "/pages/watch-repair-servicing-boca-raton": "/book/jewelry-watch-repair-consultation",
  "/pages/cleaning-polishing": "/book/jewelry-watch-repair-consultation",
  "/pages/custom-engravings": "/book/jewelry-watch-repair-consultation",
  "/pages/custom-design-boca-raton": "/book/custom-jewelry-design-consultation",
  "/pages/collateral-loans-boca-raton": "/book/collateral-loan-consultation",
  "/pages/designer-handbag-loans-boca-raton": "/book/collateral-loan-consultation",
  "/pages/gold-precious-metal-loans-boca-raton": "/book/collateral-loan-consultation",
  "/pages/jewelry-collateral-loans-boca-raton": "/book/collateral-loan-consultation",
  "/pages/rolex-collateral-loans-boca-raton": "/book/collateral-loan-consultation",
  "/pages/consignment-boca-raton": "/book/consignment-consultation",
  "/pages/jewelry-consignment-boca-raton": "/book/consignment-consultation",
  "/pages/watch-consignment-boca-raton": "/book/consignment-consultation",
  "/pages/sell-watches-boca-raton": "/book/sell-watch-appointment",
  "/pages/sell-rolex-boca-raton": "/book/sell-watch-appointment",
  "/pages/sell-audemars-piguet-watches-boca-raton": "/book/sell-watch-appointment",
  "/pages/sell-patek-philippe-boca-raton": "/book/sell-watch-appointment",
  "/pages/sell-watch-contact-form": "/book/sell-watch-appointment",
  "/pages/sell-jewelry-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-diamonds-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-engagement-ring-in-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-estate-jewelry-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-estate-jewelry-in-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-gold-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-david-yurman-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-van-cleef-arpels-boca-raton": "/book/sell-your-jewelry-diamonds",
  "/pages/sell-luxury-handbags-in-boca-raton": "/book/sell-luxury-handbags",
  "/pages/sell-chanel-handbags-boca-raton": "/book/sell-luxury-handbags",
  "/pages/sell-hermes-handbags-boca-raton": "/book/sell-luxury-handbags",
  "/pages/sell-louis-vuitton-boca-raton": "/book/sell-luxury-handbags",
  "/pages/sell-quote": "/book/instant-sell-quote",
  "/pages/how-it-works": "/book/instant-sell-quote",
  "/pages/sell-luxury-items-boca-raton": "/book/instant-sell-quote",
  "/pages/proposal-planning-in-boca-raton": "/book/private-appointment-proposalconstulation",
  "/pages/proposal-planning-services-boca-raton": "/book/private-appointment-proposalconstulation",
  "/pages/jewelry-appraisal-boca-raton": "/book/jewelry-appraisal-appointment",
  "/pages/insurance-replacement": "/book/insurance-replacement-consultation",
  "/pages/trade-in-boca-raton": "/book/trade-in-shopping-appointment",
  "/pages/fine-jewelry": "/book/fine-jewelry-shopping-appointment",
  "/pages/gabriel-co": "/book/fine-jewelry-shopping-appointment",
  "/pages/bee-goddess-story": "/book/fine-jewelry-shopping-appointment",
  "/pages/financing-and-layaway-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/pre-owned-rolex-watches-for-sale-in-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/emerald-rings-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/ruby-rings-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/sapphire-rings-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/tanzanite-rings-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/sapphire-jewelry-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/emerald-jewelry-boca-raton": "/book/fine-jewelry-shopping-appointment",
  "/pages/high-jewelry": "/high-jewelry",
  "/pages/sell-cartier-boca-raton": "/book/sell-your-jewelry-diamonds"
};
  function pageBooking(){
    const path=location.pathname.replace(/\/$/,'');
    if(pageBookings[path])return pageBookings[path];
    if(/^\/collections\/[^/]+$/.test(path)){
      if(path.includes('/high-jewelry'))return '/high-jewelry';
      const bridal=/engagement|wedding|bridal|loose-diamond/.test(path);
      return '/book/'+(bridal?'engagement-bridal-consultation':'fine-jewelry-shopping-appointment');
    }
    return null;
  }
  function destination(a){
    let u;try{u=new URL(a.getAttribute('href')||'/',location.href);}catch{return null;}
    const legacy=u.hostname==='calendly.com'&&u.pathname.startsWith('/diamondsbyraymondlee');
    const native=a.hasAttribute('data-native-booking')||u.origin===origin||u.hostname==='book.diamondsbyraymondlee.com';
    const anchor=u.origin===location.origin&&['#book-your-visit','#book-product-visit','#book-your-appointment'].includes(u.hash);
    if(!legacy&&!native&&!anchor)return null;
    if(anchor){const mount=document.getElementById(u.hash.slice(1));const target=mount?.querySelector('a[data-native-booking]');if(target)return destination(target);}
    const next=new URL(legacy?legacyPath(u):native?u.pathname:'/',origin);
    if(a.hasAttribute('data-dbrl-concierge'))next.pathname='/high-jewelry';
    // Keep explicit services and product-specific appointments intact.
    if(next.pathname==='/'&&!['product','variant','piece'].some(key=>u.searchParams.has(key)||a.dataset[key])){
      const contextual=pageBooking();
      if(contextual){const target=new URL(contextual,origin);next.pathname=target.pathname;next.search=target.search;}
    }
    if(next.pathname==='/high-jewelry'&&u.searchParams.get('request')==='1')next.searchParams.set('request','1');
    const here=new URL(location.href);
    for(const key of contextKeys){const value=u.searchParams.get(key)||a.dataset[key]||(!['product','variant'].includes(key)?here.searchParams.get(key):null);if(value)next.searchParams.set(key,value.slice(0,key==='a1'?1500:200));}
    // Read the live form at click time; Shopify may switch variants without replacing this link.
    const productHandle=next.searchParams.get('product');
    const currentHandle=location.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
    if(productHandle&&currentHandle&&productHandle===decodeURIComponent(currentHandle)){
      const scope=a.closest('product-info')||document.querySelector('product-info');
      const selected=scope?.querySelector('form[action*="/cart/add"] input[name="id"]');
      if(selected){
        const id=selected.value.trim();
        if(/^\d+$/.test(id))next.searchParams.set('variant',id);
        else next.searchParams.delete('variant');
      }
    }
    return next.href;
  }
  function setup(){for(const a of document.querySelectorAll('a[href]')){if(a.hasAttribute('data-booking-fallback'))continue;const next=destination(a);if(next&&a.getAttribute('href')!==next){a.href=next;a.dataset.nativeBooking='';a.removeAttribute('onclick');a.removeAttribute('target');}}}
  let panel, frame, opener;
  function openInline(url, trigger, focus=true){
    const main=document.querySelector('main');if(!main)return;
    opener=trigger||opener;
    if(!panel || !panel.isConnected){
      panel=document.createElement('section');panel.className='dbrl-inline-booking';panel.id='dbrl-inline-booking';panel.setAttribute('aria-labelledby','dbrl-inline-booking-title');
      panel.innerHTML='<div class="dbrl-inline-booking-heading"><h2 id="dbrl-inline-booking-title" tabindex="-1">Book your appointment</h2><button type="button" class="dbrl-inline-booking-close" aria-label="Close appointment booking">Close</button></div><p>Choose your visit, then select an available date and time.</p><iframe title="Appointment booking" class="dbrl-inline-booking-frame"></iframe><p class="dbrl-inline-booking-help">Booking not appearing? <a data-booking-fallback target="_blank" rel="noopener">Open booking in a new tab</a>, then <button type="button" data-booking-reload>reload here</button>.</p>';
      const hero=main.querySelector('.service-hero, .hj-hero, .product');
      if(location.pathname.startsWith('/collections/'))main.before(panel);else if(hero)hero.after(panel);else main.prepend(panel);
      frame=panel.querySelector('iframe');
      panel.querySelector('.dbrl-inline-booking-close').addEventListener('click',()=>{panel.hidden=true;opener?.focus();});
      panel.querySelector('[data-booking-reload]').addEventListener('click',()=>{frame.src=frame.src;});
    }
    panel.hidden=false;const embedded=new URL(url);embedded.searchParams.set('embed','1');
    if(frame.getAttribute('src')!==embedded.href){frame.style.height='780px';frame.src=embedded.href;}
    panel.querySelector('[data-booking-fallback]').href=url;
    if(focus){panel.scrollIntoView({behavior:'instant',block:'start'});panel.querySelector('h2').focus({preventScroll:true});}
  }
  // The native iframe emits anonymous stages; only this exact frame can publish them.
  const bookingAnalyticsSeen = new Set(), bookingAnalyticsPending = new Map();
  let bookingAnalyticsTimer, bookingAnalyticsRetries = 0;
  const bookingStages = new Set(['opened','service_viewed','time_selected','confirmed','requested','external_opened']);
  const bookingServices = new Set(['general','bridal','sell_watch','sell_jewelry_diamonds','sell_handbag','consignment','collateral','repair','appraisal','custom_design','insurance_replacement','high_jewelry']);
  function publishBooking(d) {
    try {
      if (origin !== fallback || !['https://diamondsbyraymondlee.com','https://www.diamondsbyraymondlee.com'].includes(location.origin)) return;
      if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || new URLSearchParams(location.search).has('analytics_test')) return;
      if (!bookingStages.has(d.stage) || !bookingServices.has(d.booking_service) || typeof d.event_id !== 'string' || !/^native-[a-zA-Z0-9_-]{16,100}$/.test(d.event_id) || bookingAnalyticsSeen.has(d.event_id)) return;
      if (!window.Shopify?.analytics?.publish) {
        if (bookingAnalyticsPending.size < 50) bookingAnalyticsPending.set(d.event_id, {stage:d.stage,booking_service:d.booking_service,event_id:d.event_id});
        if (!bookingAnalyticsTimer && bookingAnalyticsRetries < 40) bookingAnalyticsTimer=setTimeout(()=>{
          bookingAnalyticsTimer=null; bookingAnalyticsRetries++;
          const batch=[...bookingAnalyticsPending.values()];bookingAnalyticsPending.clear();batch.forEach(publishBooking);
        },250);
        return;
      }
      bookingAnalyticsPending.delete(d.event_id);
      bookingAnalyticsSeen.add(d.event_id);
      const pending = window.Shopify.analytics.publish('dbrl:native_booking', {
        stage:d.stage, booking_service:d.booking_service, event_id:d.event_id,
        page_path:location.pathname, placement:'inline', preview:false
      });
      if (pending?.catch) pending.catch(()=>bookingAnalyticsSeen.delete(d.event_id));
    } catch { /* Measurement must never interrupt the appointment flow. */ }
  }
  let stepScrollTimer;
  window.addEventListener('message',e=>{
    if(e.origin!==origin||!frame||e.source!==frame.contentWindow)return;
    if(e.data?.type==='dbrl-booking-analytics'){
      if(!panel || (panel.hidden && !['confirmed','requested'].includes(e.data.stage)))return;
      const d=e.data;
      if(d.stage==='service_viewed')publishBooking({...d,stage:'opened',event_id:d.event_id.replace(/-service_viewed$/,'-opened')});
      publishBooking(d);
      return;
    }
    if(e.data?.type==='dbrl-booking-size'){
      const height=Number(e.data.height);
      if(Number.isFinite(height))frame.style.height=Math.min(6000,Math.max(400,height+12))+'px';
      return;
    }
    if(!['dbrl-booking-result','dbrl-booking-review'].includes(e.data?.type)||panel.hidden)return;
    const offset=e.data.offsetTop;
    if(typeof offset!=='number'||!Number.isFinite(offset)||offset<0||offset>6000)return;
    clearTimeout(stepScrollTimer);
    const currentFrame=frame, currentSource=frame.src;
    stepScrollTimer=setTimeout(()=>{
      if(panel.hidden||frame!==currentFrame||frame.src!==currentSource)return;
      const top=Math.max(0,frame.getBoundingClientRect().top+window.scrollY+offset-24);
      window.scrollTo({top,behavior:'instant'});
    },120);
  });
  document.addEventListener('click',event=>{const a=event.target.closest('a');if(!a||a.hasAttribute('data-booking-fallback'))return;const next=destination(a);if(!next)return;a.href=next;event.stopImmediatePropagation();if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();openInline(next,a);},true);
  if(location.pathname.replace(/\/$/,'')==='/pages/schedule-an-appointment')openInline(origin+'/',null,false);
  setup();document.addEventListener('shopify:section:load',setup);
  let pending=false;new MutationObserver(()=>{if(pending)return;pending=true;queueMicrotask(()=>{pending=false;setup();});}).observe(document.body,{childList:true,subtree:true});
})();
